import type { ProjectListResponsePageAllOf } from './projectListResponsePageAllOf';
import type { ProjectListResponsePageAllOfThree } from './projectListResponsePageAllOfThree';

export type ProjectListResponsePage = ProjectListResponsePageAllOf & ProjectListResponsePageAllOfThree;
